import { LayerSpecification } from 'mapbox-gl'

export class MapFillLayerFactory {
	static make(source: string = 'shape', id: string = 'Fill'): LayerSpecification {
		return {
			id,
			type: 'fill',
			source,
			paint: {
				'fill-color': ['coalesce', ['get', 'cor'], '#FEFEFE'],
				'fill-opacity': ['coalesce', ['get', 'preenchimento'], 0.2],
			},
		}
	}
}
